import script from "./Group3EditModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./Group3EditModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__